// 12x12 monochrome pixel-art sprites. '#' = lit pixel, '.' = empty.

export const SPRITES = {
  doc: [
    '.########...',
    '.#......##..',
    '.#......###.',
    '.#........#.',
    '.#.####...#.',
    '.#........#.',
    '.#.######.#.',
    '.#........#.',
    '.#.####...#.',
    '.#........#.',
    '.#........#.',
    '.##########.'
  ],
  globe: [
    '....####....',
    '..##....##..',
    '.#..##....#.',
    '#..####....#',
    '#...##.....#',
    '#......###.#',
    '#.....####.#',
    '#......##..#',
    '#...#......#',
    '.#.###....#.',
    '..##....##..',
    '....####....'
  ],
  question: [
    '....####....',
    '..##....##..',
    '.##......##.',
    '.##......##.',
    '.........##.',
    '........##..',
    '......###...',
    '.....##.....',
    '.....##.....',
    '............',
    '.....##.....',
    '.....##.....'
  ],
  // small glyphs the pixel font does not ship with
  play: [
    '#....',
    '##...',
    '###..',
    '####.',
    '#####',
    '####.',
    '###..',
    '##...',
    '#....'
  ],
  down: [
    '#########',
    '.#######.',
    '..#####..',
    '...###...',
    '....#....'
  ],
  dot: [
    '.##.',
    '####',
    '####',
    '.##.'
  ]
};

// 16x16 desktop icons
SPRITES.folder = [
  '................',
  '.######.........',
  '#......#........',
  '#.......########',
  '################',
  '#..............#',
  '#..............#',
  '#..............#',
  '#..............#',
  '#..............#',
  '#..............#',
  '#..............#',
  '#..............#',
  '################',
  '................',
  '................'
];
SPRITES.calendar = [
  '................',
  '...#........#...',
  '...#........#...',
  '################',
  '#..............#',
  '################',
  '#..............#',
  '#.##.##.##.##..#',
  '#..............#',
  '#.##.##.##.##..#',
  '#..............#',
  '#.##.##........#',
  '#..............#',
  '################',
  '................',
  '................'
];
SPRITES.linkedin = [
  '..############..',
  '.#............#.',
  '#..............#',
  '#..............#',
  '#...##.........#',
  '#..............#',
  '#...##..####...#',
  '#...##.##..##..#',
  '#...##.##..##..#',
  '#...##.##..##..#',
  '#...##.##..##..#',
  '#..............#',
  '#..............#',
  '.#............#.',
  '..############..',
  '................'
];
SPRITES.x = [
  '..############..',
  '.#............#.',
  '#..............#',
  '#..##......##..#',
  '#...##....##...#',
  '#....##..##....#',
  '#.....####.....#',
  '#......##......#',
  '#.....####.....#',
  '#....##..##....#',
  '#...##....##...#',
  '#..##......##..#',
  '#..............#',
  '.#............#.',
  '..############..',
  '................'
];
